
import { useParams } from "react-router-dom";
import styles from "./style.module.css";

const baseUrl = process.env.REACT_APP_RADAR_URL;
const ongoing = "ONGOING";

export default function RadarMapView({ tripStatus }) {
  const { awbInfo } = useParams();
  
  if (!awbInfo || tripStatus !== ongoing) return null;

  return (
    <div className={styles.radar_map_view_wrapper}>
      <iframe
        className={styles.radar_i_frame}
        src={`${baseUrl}/${awbInfo}`}
        title="Blitz live tracking"
      ></iframe>
    </div>
  );
}
